import { STATIC_BASE } from './runtimeConfig';

// Brand @font-face injected at runtime — the per-env CDN apex can't be a
// build-time constant (one build serves all envs). font-display: swap avoids
// invisible text while the font streams.
export function injectBrandFonts(): void {
  if (typeof document === 'undefined' || document.getElementById('wp-brand-fonts')) return;

  const pre = document.createElement('link');
  pre.rel = 'preconnect';
  pre.href = STATIC_BASE;
  pre.crossOrigin = 'anonymous';
  document.head.appendChild(pre);

  const b = STATIC_BASE;
  const moderat = (weight: number, file: string) =>
    `@font-face{font-family:'Moderat';font-style:normal;font-weight:${weight};font-display:swap;` +
    `src:url('${b}/fonts/moderat/${file}.woff2') format('woff2'),url('${b}/fonts/moderat/${file}.woff') format('woff');}`;
  const tomato = (weight: number, file: string) =>
    `@font-face{font-family:'Tomato Grotesk';font-style:normal;font-weight:${weight};font-display:swap;` +
    `src:url('${b}/fonts/tomato-grotesk/${file}.otf') format('opentype');}`;

  const css = [
    moderat(300, 'Moderat-Light'),
    moderat(400, 'Moderat-Regular'),
    moderat(500, 'Moderat-Medium'),
    moderat(700, 'Moderat-Bold'),
    tomato(400, 'TomatoGrotesk-Regular'),
    tomato(500, 'TomatoGrotesk-Medium'),
    tomato(600, 'TomatoGrotesk-SemiBold'),
    tomato(700, 'TomatoGrotesk-Bold'),
  ].join('');

  const style = document.createElement('style');
  style.id = 'wp-brand-fonts';
  style.textContent = css;
  document.head.appendChild(style);
}
